import { Empty, Button } from 'antd';
import * as React from 'react';
import t from 'utils/translations';

const EmptyList = () => {
    return (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('NO_GROUPS')}
        ></Empty>
    );
};
export default EmptyList;
